import type { PageAccess, PageAccessKey } from '@/entities/Administration';

export type ResolvedPageAccess = PageAccessKey | 'dashboard' | 'unmapped';

export function pathnameToPageAccessRequirement(pathname: string): ResolvedPageAccess {
  const p = pathname.split('?')[0];
  if (p === '/' || p === '') return 'dashboard';
  if (p.startsWith('/courses')) return 'courses';
  if (p.startsWith('/active')) return 'students';
  if (p.startsWith('/applicants')) return 'applicants';
  if (p.startsWith('/profiles')) return 'students';
  if (p.startsWith('/growth-system')) return 'badges';
  if (p.startsWith('/requests-reports')) return 'requestsReports';
  if (p.startsWith('/academic-staff')) return 'staff';
  if (p.startsWith('/assignments-test')) return 'assignments';
  if (p.startsWith('/certificates')) return 'certificates';
  if (p.startsWith('/push-notifications')) return 'notifications';
  if (p.startsWith('/administration')) return 'administration';
  if (p.startsWith('/attributes')) return 'attributes';
  if (p.startsWith('/locations')) return 'locations';
  if (p.startsWith('/payments')) return 'payments';
  if (p.startsWith('/articles')) return 'articles';
  if (p.startsWith('/schedule-events')) return 'courses';
  if (p.startsWith('/operations-center')) return 'requestsReports';
  if (p.startsWith('/community')) return 'articles';
  if (p.startsWith('/career-hub')) return 'articles';
  return 'unmapped';
}

export function isPathAllowed(pathname: string, pageAccess: PageAccess | null): boolean {
  if (!pageAccess) return true;
  const req = pathnameToPageAccessRequirement(pathname);
  if (req === 'dashboard' || req === 'unmapped') return true;
  return pageAccess[req] === true;
}
